import EPGChannelPicker from './EPGChannelPicker';

export default EPGChannelPicker;
